import {
  Chip,
  MenuItem,
  TextField,
  Grid,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { Search } from "lucide-react";
import { DOCUMENT_TYPES } from "../config/DocumentConfig";

const StockTransferInGeneral = ({
  WorkOrderData,
  setWorkOrderData,
  drAccount,
  setDrAccount,
  drDesc,
  setDrDesc,
  crAccount,
  setCrAccount,
  crDesc,
  setCrDesc,
  BASE_URL,
  COMPANY_CODE,
  DEPARTMENT_NO,
  type = "SAMPLEISSUE",
  setModalState,
  handleBranchTransferDocList, setShowBranchTransferModal

}) => {
  const { request, loading } = useApi();
  const [salesmanList, setSalesmanList] = useState([]);
  const isSampleIssue = type === "SAMPLERETURN";

  const displayDrAccount = isSampleIssue ? crAccount : drAccount;
  const displayDrDesc = isSampleIssue ? crDesc : drDesc;

  const displayCrAccount = isSampleIssue ? drAccount : crAccount;
  const displayCrDesc = isSampleIssue ? drDesc : crDesc;

  const fetchList = async (url, setter) => {
    try {
      const response = await request({
        url,
        method: "GET",
        timeout: 10000,
      });
      setter(response || []);
    } catch (err) {
      console.error("Fetch error:", err);
      setter([]);
    }
  };

  useEffect(() => {
    fetchList(
      `${BASE_URL}/api/MasterCount/${COMPANY_CODE}/SALESPERSONLIST/-/${DEPARTMENT_NO}`,
      setSalesmanList,
    );
  }, []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 p-3">
      <div className="lg:col-span-4 col-span-1 flex flex-col gap-2">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">P Iss:</span>
            <span className="text-red-600 font-bold text-base leading-tight">
              {WorkOrderData?.documentNo || "-"}
            </span>
          </div>
          <TextField
            label="Date"
            type="date"
            variant="outlined"
            size="small"
            value={
              WorkOrderData?.date || new Date().toISOString().split("T")[0]
            }
            onChange={(e) =>
              setWorkOrderData({
                ...WorkOrderData,
                date: e.target.value,
              })
            }
            InputLabelProps={{ shrink: true }}
            sx={{
              minWidth: "140px",
              "& .MuiInputBase-root": { height: "36px" },
            }}
          />
        </div>

        <Grid container spacing={1}>
          {/* DR Account */}
          <Grid item xs={6}>
            <TextField
              fullWidth
              size="small"
              label="Dr Account"
              value={displayDrAccount}
              onChange={(e) =>
                setWorkOrderData({
                  ...WorkOrderData,
                  drAccountLocal: e.target.value,
                })
              }
              onKeyDown={(e) => {
                if (e.key === "F2") {
                  e.preventDefault();
                  setModalState({
                    isOpen: true,
                    type: "credit-customer",
                    target: "dr",
                    defaultType: type === DOCUMENT_TYPES.BRANCH_TRANSFER ? "InterCompany" : "Expenses",
                  });
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() =>
                        setModalState({
                          isOpen: true,
                          type: "credit-customer",
                          target: "dr",
                          defaultType: type === DOCUMENT_TYPES.BRANCH_TRANSFER ? "InterCompany" : "Expenses",
                        })
                      }
                    >
                      <Search size={16} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              size="small"
              label="DR Description"
              value={displayDrDesc}
              sx={{ mt: 1 }}
              slotProps={{
                input: { readOnly: true },
              }}
            />
          </Grid>

          {/* CR Account */}
          <Grid item xs={6}>
            <TextField
              fullWidth
              size="small"
              label="Cr Account"
              value={displayCrAccount}
              onChange={(e) => setCrAccount(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "F2") {
                  e.preventDefault();
                  setModalState({
                    isOpen: true,
                    type: "credit-customer",
                    target: "cr",
                    defaultType: "InterCompany",
                  });
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() =>
                        setModalState({
                          isOpen: true,
                          type: "credit-customer",
                          target: "cr",
                          defaultType: "InterCompany",
                        })
                      }
                    >
                      <Search className=" text-gray-500" size={16} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              size="small"
              label="CR Description"
              value={displayCrDesc}
              sx={{ mt: 1 }}
              slotProps={{
                input: { readOnly: true },
              }}
            />
          </Grid>

          {/* Branch Transfer Doc List Button */}
          {/* <div className="flex justify-center items-center">
            <button
              className="rounded-md bg-blue-400 hover:bg-blue-500 text-white py-1"
              // variant="outlined"
              fullWidth
              size="small"

              onClick={() => setShowBranchTransferModal(true)}
            >
              Branch Transfer Doc List
            </button>
          </div> */}
        </Grid>
      </div>

      <div className="lg:col-span-4 col-span-1">
        <div className="grid grid-cols-2 gap-2">
          <TextField
            label="Job Code"
            name="job"
            value={WorkOrderData.job}
            onChange={(e) =>
              setWorkOrderData({
                ...WorkOrderData,
                job: e.target.value,
              })
            }
            onKeyDown={(e) => {
              if (e.key === "F2") {
                e.preventDefault();
                setModalState({
                  isOpen: true,
                  type: "job-list",
                });
              }
            }}
            fullWidth
            // variant="filled"
            size="small"
            autoComplete="off"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setModalState({
                        isOpen: true,
                        type: "job-list",
                      })
                    }
                    size="small"
                    sx={{
                      padding: 0.3,
                    }}
                  >
                    <Search className=" text-gray-500" size={16} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            label="Cost Center"
            name="costCenter"
            value={WorkOrderData?.costCenter || ""}
            onChange={(e) =>
              setWorkOrderData({
                ...WorkOrderData,
                costCenter: e.target.value,
              })
            }
            onKeyDown={(e) => {
              if (e.key === "F2") {
                e.preventDefault();
                setModalState({
                  isOpen: true,
                  type: "cost-center-list",
                });
              }
            }}
            fullWidth
            size="small"
            autoComplete="off"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setModalState({
                        isOpen: true,
                        type: "cost-center-list",
                      })
                    }
                    size="small"
                    sx={{
                      padding: 0.3,
                    }}
                  >
                    <Search className=" text-gray-500" size={16} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            select
            label="Sales Person"
            variant="outlined"
            size="small"
            fullWidth
            // slotProps={{
            //   input: {
            //     readOnly: true,
            //   },
            // }}
            value={WorkOrderData?.salespersonId || ""}
            onChange={(e) =>
              setWorkOrderData({
                ...WorkOrderData,
                salespersonId: e.target.value,
              })
            }
          >
            {salesmanList?.map((person) => (
              <MenuItem key={person.EMP_ID} value={person.EMP_ID}>
                {person.NAME}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Requested By"
            variant="outlined"
            size="small"
            fullWidth
            value={WorkOrderData?.requestedBy || ""}
            onChange={(e) =>
              setWorkOrderData({
                ...WorkOrderData,
                requestedBy: e.target.value,
              })
            }
          >
            {salesmanList?.map((person) => (
              <MenuItem key={person.EMP_ID} value={person.EMP_ID}>
                {person.NAME}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </div>

      <div className="lg:col-span-4 col-span-2">
        <div className="grid grid-cols-2 gap-2 mb-2">
          <TextField
            fullWidth
            size="small"
            label="Source Department"
            value={WorkOrderData?.customer || ""}
            InputProps={{ readOnly: true }}
          />
          {/* <TextField
            select
            label="Transfer Status"
            variant="outlined"
            size="small"
            fullWidth
            value={WorkOrderData?.transferStatus || ""}
            onChange={(e) =>
              setWorkOrderData({
                ...WorkOrderData,
                transferStatus: e.target.value,
              })
            }
          >
            <MenuItem value="DRAFT">DRAFT</MenuItem>
            <MenuItem value="CONFIRM">CONFIRM</MenuItem>
            <MenuItem value="CANCELLED">CANCELLED</MenuItem>
          </TextField> */}
          <button
            className="rounded-md bg-blue-400 hover:bg-blue-500 text-white py-1"
            onClick={() => setShowBranchTransferModal(true)}
          >
            Branch Transfer Doc List
          </button>
        </div>
        <TextField
          multiline
          fullWidth
          size="small"
          label="Remarks"
          rows={2}
          value={WorkOrderData?.remarks || ""}
          onChange={(e) =>
            setWorkOrderData({
              ...WorkOrderData,
              remarks: e.target.value,
            })
          }
        />
      </div>
    </div>
  );
};

export default StockTransferInGeneral;
